import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["checked"]
const _hoisted_3 = { class: "multiselect-checkbox__label" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "observer" }
const _hoisted_6 = {
  key: 0,
  class: "i-count i-count--variant_fixed"
}
const _hoisted_7 = { class: "i-count__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i_chevron_down = _resolveComponent("i-chevron-down")!
  const _directive_intersection_observer = _resolveDirective("intersection-observer")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["d-control-input", { error: $props.errors[$props.name], success: $props.isSuccess }])
  }, [
    _createVNode($setup["VueMultiselect"], _mergeProps({
      class: ["d-control-input__element", { "is-multiple": $props.multiple, "is-searchable": $props.searchable }]
    }, _ctx.$attrs, {
      options: $setup.localOptions,
      label: $props.labelBy,
      "track-by": $props.trackBy,
      placeholder: $props.placeholder,
      disabled: $props.disabled,
      "allow-empty": $props.allowEmpty,
      modelValue: $setup.model,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => (($setup.model) = $event)),
        $setup.check
      ],
      required: $props.rules,
      value: $setup.model,
      multiple: $props.multiple,
      "show-labels": false,
      searchable: $props.searchable,
      "custom-label": $props.customLabel,
      "close-on-select": $props.multiple ? false : $props.closeOnSelect
    }), _createSlots({
      selection: _withCtx(({values}) => []),
      caret: _withCtx(({ toggle }) => [
        _createVNode(_component_i_chevron_down, {
          class: "multiselect-caret",
          onMousedown: _withModifiers(($event: any) => (toggle()), ["prevent","stop"])
        }, null, 8, ["onMousedown"])
      ]),
      option: _withCtx(({ option }) => [
        ($props.multiple)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "multiselect-checkbox",
              onClick: _withModifiers(($event: any) => ($setup.select(option)), ["self"])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["gt-checkbox-main", option.selected ? 'gt-checkbox-main--active' : 'gt-checkbox-main'])
              }, [
                _createElementVNode("input", {
                  class: "all-selector-input checker",
                  type: "checkbox",
                  checked: option.selected
                }, null, 8, _hoisted_2),
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "gt-checkbox-main__label" }, [
                  _createElementVNode("img", { src: "/static/app/check.svg" })
                ], -1))
              ], 2),
              _createElementVNode("p", _hoisted_3, _toDisplayString($setup.getOptionLabel(option)), 1)
            ], 8, _hoisted_1))
          : (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString($setup.getOptionLabel(option)), 1))
      ]),
      noResult: _withCtx(({ search }) => [
        _createTextVNode(_toDisplayString($setup.noResultText), 1)
      ]),
      noOptions: _withCtx(() => [
        _createTextVNode(_toDisplayString($setup.noOptionsText), 1)
      ]),
      _: 2
    }, [
      _renderList($setup.eSlots, (name, key) => {
        return {
          name: name,
          fn: _withCtx((binded) => [
            _renderSlot(_ctx.$slots, key, _normalizeProps(_guardReactiveProps(binded)))
          ])
        }
      }),
      ($props.pagination && $props.pagination.total > $props.pagination.offset + $props.pagination.limit)
        ? {
            name: "afterList",
            fn: _withCtx(() => [
              _createElementVNode("li", null, [
                _withDirectives(_createElementVNode("div", _hoisted_5, null, 512), [
                  [_directive_intersection_observer, $setup.visibilityChanged]
                ])
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1040, ["class", "options", "label", "track-by", "placeholder", "disabled", "allow-empty", "modelValue", "required", "value", "multiple", "searchable", "custom-label", "close-on-select"]),
    _renderSlot(_ctx.$slots, "label"),
    ($setup.model?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString($setup.model?.length), 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}